import React from 'react'

const WelcomeBlockedView = () => {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-white">
      <img 
        src="/images/logo_blue.png" 
        alt="VACWAYlockers" 
        height={56}
        className="mb-6"
      />
      <h1 className="text-3xl font-semibold text-gray-800">
        Bienvenido a VACWAYlockers Management
      </h1>
    </div>
  )
}

export default WelcomeBlockedView
